import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
declare var jQuery: any;

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  private displayPageIntro:boolean = false;
  private togglePageIntro = new Subject<boolean>();
  showFullText$ = this.togglePageIntro.asObservable();
  
  constructor() {
  }

  keyPress(event: any) {
    const pattern = /[0-9]+/;

    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  showHidePageIntro() {
    this.togglePageIntro.next(this.displayPageIntro);
  }

}
